/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NodataReturnOrderGoodsDto
 */
export interface NodataReturnOrderGoodsDto {
    /**
     * 生成订单的商品ID，非历史来源商品ID。
     * @type {number}
     * @memberof NodataReturnOrderGoodsDto
     */
    id?: number;
    /**
     * 生成订单的商品编号。
     * @type {string}
     * @memberof NodataReturnOrderGoodsDto
     */
    code?: string;
    /**
     * SKU ID，无SKU的商品为空。
     * @type {number}
     * @memberof NodataReturnOrderGoodsDto
     */
    skuId?: number;
    /**
     * 商品名称。
     * @type {string}
     * @memberof NodataReturnOrderGoodsDto
     */
    name?: string;
    /**
     * 商品图片。
     * @type {string}
     * @memberof NodataReturnOrderGoodsDto
     */
    imgUrl?: string;
    /**
     * 颜色。
     * @type {string}
     * @memberof NodataReturnOrderGoodsDto
     */
    color?: string;
    /**
     * 尺码。
     * @type {string}
     * @memberof NodataReturnOrderGoodsDto
     */
    size?: string;
    /**
     * 本次返送订单申请数量，不是历史数量或实时可用库存。
     * @type {number}
     * @memberof NodataReturnOrderGoodsDto
     */
    quantity?: number;
    /**
     * 是否为组合商品，0基础商品、1组合商品。
     * @type {number}
     * @memberof NodataReturnOrderGoodsDto
     */
    combined?: number;
    /**
     * 每套构成数量，仅组合商品构成项返回。
     * @type {number}
     * @memberof NodataReturnOrderGoodsDto
     */
    constructCount?: number;
    /**
     * 组合商品构成项，独立商品返回空列表。
     * @type {Array<NodataReturnOrderGoodsDto>}
     * @memberof NodataReturnOrderGoodsDto
     */
    baseGoods?: Array<NodataReturnOrderGoodsDto>;
}

/**
 * Check if a given object implements the NodataReturnOrderGoodsDto interface.
 */
export function instanceOfNodataReturnOrderGoodsDto(value: object): value is NodataReturnOrderGoodsDto {
    return true;
}

export function NodataReturnOrderGoodsDtoFromJSON(json: any): NodataReturnOrderGoodsDto {
    return NodataReturnOrderGoodsDtoFromJSONTyped(json, false);
}

export function NodataReturnOrderGoodsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NodataReturnOrderGoodsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'code': json['code'] == null ? undefined : json['code'],
        'skuId': json['skuId'] == null ? undefined : json['skuId'],
        'name': json['name'] == null ? undefined : json['name'],
        'imgUrl': json['imgUrl'] == null ? undefined : json['imgUrl'],
        'color': json['color'] == null ? undefined : json['color'],
        'size': json['size'] == null ? undefined : json['size'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'combined': json['combined'] == null ? undefined : json['combined'],
        'constructCount': json['constructCount'] == null ? undefined : json['constructCount'],
        'baseGoods': json['baseGoods'] == null ? undefined : ((json['baseGoods'] as Array<any>).map(NodataReturnOrderGoodsDtoFromJSON)),
    };
}

export function NodataReturnOrderGoodsDtoToJSON(json: any): NodataReturnOrderGoodsDto {
    return NodataReturnOrderGoodsDtoToJSONTyped(json, false);
}

export function NodataReturnOrderGoodsDtoToJSONTyped(value?: NodataReturnOrderGoodsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'skuId': value['skuId'],
        'name': value['name'],
        'imgUrl': value['imgUrl'],
        'color': value['color'],
        'size': value['size'],
        'quantity': value['quantity'],
        'combined': value['combined'],
        'constructCount': value['constructCount'],
        'baseGoods': value['baseGoods'] == null ? undefined : ((value['baseGoods'] as Array<any>).map(NodataReturnOrderGoodsDtoToJSON)),
    };
}

